<template>
  <v-app id="list">
    <v-container>
      <v-row class="mb-3">
        <v-col v-for="user in users" :key="user.userId">
          <v-card width="200" height="200" @click="settingCrush(user)">
            <v-row>
              <v-col class="text-center">
                <img
                  height="100"
                  width="100"
                  :src="user.userPic"
                  class="rounded-circle"
                />
              </v-col>
            </v-row>
            <v-card-text class="text-h6 text-center">
              {{ user.userName }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'List',
  computed: {
    users () {
      return this.$store.state.users
    }
  },
  methods: {
    settingCrush(target) {
      this.$router.push({ name: 'settingCrush', params: { target: target }　})
    },
  },
}
</script>
